import { Reveal, Eyebrow } from "./primitives.jsx";
import { useSiteContent } from "../content.js";

// The "I have opinions about your baseball." headline and the takes board are
// intentionally unrendered (Aug 2026, Greg's call) — this section is just the
// weekly hot take now. The board's copy still lives in content.js, so
// restoring it is a render-only change (see git history for the old markup).
export default function MyTake() {
  const { mytake: copy } = useSiteContent();

  return (
    <section id="mytake" data-screen-label="06 My Take" className="section take">
      <div className="section-inner">
        <Reveal>
          <Eyebrow index="06">{copy.eyebrow}</Eyebrow>
        </Reveal>

        <Reveal delay={160}>
          <div className="hot-take">
            <div className="hot-take-stripe" />
            <div className="hot-take-inner">
              <div className="hot-take-header">
                <span className="hot-take-tag mono">{copy.weeklyTag}</span>
                <span className="hot-take-date mono">
                  {copy.weekly.date} · {copy.weekly.team} · {copy.weekly.record}
                </span>
              </div>
              <p className="hot-take-body">{copy.weekly.take}</p>
              <div className="hot-take-foot mono">{copy.weeklyFoot}</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

const takeStyles = document.createElement("style");
takeStyles.textContent = `
.take { background: var(--navy-900); }

.hot-take {
  margin-top: 40px;
  position: relative;
  background: linear-gradient(135deg, #2a0a0a 0%, #1a0606 100%);
  border: 1px solid var(--crimson);
  overflow: hidden;
}
.hot-take-stripe { position: absolute; left: 0; top: 0; bottom: 0; width: 6px; background: var(--crimson); }
.hot-take-inner { padding: 32px 40px 32px 56px; }
.hot-take-header { display: flex; gap: 20px; flex-wrap: wrap; align-items: center; margin-bottom: 16px; }
.hot-take-tag { font-size: 0.6875rem; letter-spacing: 0.22em; color: var(--crimson); }
.hot-take-date { font-size: 0.625rem; letter-spacing: 0.14em; color: var(--bone-dim); }
.hot-take-body { font-family: var(--serif); font-size: clamp(1.25rem, 2vw, 1.625rem); line-height: 1.4; color: var(--bone); margin: 0 0 16px; }
.hot-take-foot { font-size: 0.6875rem; color: var(--gold); letter-spacing: 0.14em; opacity: 0.8; }
`;
document.head.appendChild(takeStyles);
